<template>
    <b-modal id="modal-edit-scraper" size="lg" no-close-on-backdrop>
        <template #modal-title>
            <div class="d-flex align-items-center">
                <feather-icon size="20" icon="EditIcon" class="mr-05" />
                <span class="fs-18">Edit Scraper WordPress</span>
            </div>
        </template>

        <loader-component v-if="is_loading" />

        <b-card no-body class="mb-0">
            <b-card-body>
                <validation-observer ref="domainRules">
                    <b-form>
                        <b-form-group>
                            <validation-provider #default="{ errors }" name="Domain" rules="required">
                                <label for="domain"> Domain <span class="text-danger">*</span></label>
                                <br><small class="text-muted">Domain setidaknya mengandung titik (.)</small>
                                <b-input-group class="input-group-merge">
                                    <b-input-group-prepend is-text>
                                        <feather-icon icon="LinkIcon" />
                                    </b-input-group-prepend>

                                    <b-form-input v-model="data.domain" id="domain" placeholder="Silahkan edit scraper" />
                                </b-input-group>
                                <small class="text-danger" style="font-size: 10px">{{
                                    errors[0]
                                    }}</small>
                            </validation-provider>
                        </b-form-group>
                        <!-- Tabel hasil cek domain -->
                        <div v-if="scraper_data.length > 0" class="mt-1">
                            <b-table :items="scraper_data" :fields="['domain', 'status_db', 'status_request']" small
                                responsive bordered>
                                <template #cell(status_db)="data">
                                    <span :class="data.item.domain_available ? 'text-success' : 'text-danger'">
                                        {{ data.item.domain_available ? 'Belum Ada' : 'Sudah Ada' }}
                                    </span>
                                </template>
                                <template #cell(status_request)="data">
                                    <span :class="data.item.domain_request ? 'text-success' : 'text-danger'">
                                        {{ data.item.domain_request ? 'Valid' : 'Invalid' }}
                                    </span>
                                </template>
                            </b-table>
                        </div>
                    </b-form>
                </validation-observer>
            </b-card-body>
        </b-card>

        <template #modal-footer>
            <b-button variant="outline-danger" size="sm" class="float-right mr-05" @click="cancelAddScraper">
                Batal
            </b-button>
            <b-button v-if="!validated_domain" variant="outline-info" size="sm" class="float-right mr-05"
                @click="checkScraper">
                Check
            </b-button>
            <b-button v-if="validated_domain" variant="outline-success" size="sm" class="float-right"
                @click.prevent="submitScraper">
                Simpan
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import {
    BModal,
    VBModal,
    BCard,
    BCardBody,
    BForm,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,
    BTable,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import floating_loader from "@/views/components/floatingLoader.vue";
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { data } from "jquery";

export default {
    name: "addScraper",
    components: {
        ValidationProvider,
        ValidationObserver,
        BModal,
        BCard,
        BCardBody,
        BForm,
        BFormGroup,
        BInputGroup,
        BInputGroupPrepend,
        BFormInput,
        BButton,
        BTable,
        "loader-component": floating_loader,
    },
    props: {
        data: Object,
    },
    data() {
        return {
            is_loading: false,
            scraper_data: [],
            validated_domain: false,
            required,
        };
    },
    watch: {
        "data.domain"() {
            if (this.validated_domain) {
                this.checkScraper();
            }
        }
    },
    methods: {
        checkScraper() {
            this.$refs.domainRules.validate().then((success) => {
                if (success) {
                    this.is_loading = true;
                    const domains = this.data.domain
                        .split("\n")
                        .map((domain) => domain.trim())
                        .filter((domain) => domain !== "");
                    this.scraper_data = [];

                    let api = process.env.VUE_APP_API_URL + "wordpress/check";

                    const requestData = {
                        data: domains.map((domain) => ({ domain })),
                    };

                    useJwt.axiosIns
                        .post(api, requestData)
                        .then((res) => {
                            if (res.data.message) {
                                this.scraper_data = res.data.results.map((item) => ({
                                    domain: item.domain,
                                    domain_available: !item.exists,
                                    domain_request: item.reachable,
                                }));

                                let message = res.data?.message
                                this.$toast({
                                    component: ToastificationContent,
                                    position: "top-center",
                                    props: {
                                        title: "Gagal",
                                        icon: "AlertTriangleIcon",
                                        variant: "danger",
                                        text: message,
                                    },
                                });
                            } else {
                                this.scraper_data = res.data.results.map((item) => ({
                                    domain: item.domain,
                                    domain_available: !item.exists,
                                    domain_request: item.reachable,
                                }));
                            }

                            this.validated_domain = this.scraper_data.every(
                                (item) => item.domain_available && item.domain_request
                            );
                            this.checkButton = true;
                        })
                        .catch((err) => {
                            console.error("Gagal cek URL:", err);
                            this.scraper_data = domains.map((domain) => ({
                                domain,
                                domain_available: false,
                                domain_request: false,
                            }));
                            this.validated_domain = false;
                        })
                        .finally(() => {
                            this.is_loading = false;
                        });
                }
            });
        },
        submitScraper() {
            this.$refs.domainRules.validate().then((success) => {
                if (success && this.validated_domain) {
                    this.is_loading = true;

                    const validDomains = this.scraper_data
                        .filter((item) => item.domain_available)
                        .map((item) => item.domain);

                    const requestData = { data : { domain: validDomains[0] }};

                    const api = process.env.VUE_APP_API_URL + "wordpress/update/" + this.data._id;

                    useJwt.axiosIns
                        .put(api, requestData)  
                        .then((res) => {
                            const message = res.data.message || "Scraper berhasil diperbarui.";
                            this.scraper_data = [];
                            this.validated_domain = false;
                            this.$bvModal.hide("modal-edit-scraper");
                            this.$parent.getData();
                            this.$toast({
                                component: ToastificationContent,
                                position: "top-right",
                                props: {
                                    title: "Berhasil",
                                    icon: "CheckCircleIcon",
                                    variant: "success",
                                    text: message,
                                },
                            });
                        })
                        .catch((err) => {
                            const message = err.response?.data?.detail?.message || "Gagal menyimpan scraper.";
                            this.$toast({
                                component: ToastificationContent,
                                position: "top-right",
                                props: {
                                    title: "Gagal",
                                    icon: "AlertTriangleIcon",
                                    variant: "danger",
                                    text: message,
                                },
                            });
                        })
                        .finally(() => {
                            this.is_loading = false;
                            this.checkButton = false;
                        });
                }
            });
        },

        cancelAddScraper() {
            this.scraper_data = [];
            this.validated_domain = false;
            this.$bvModal.hide("modal-edit-scraper");
            this.checkButton = false;
        },
    },
    directives: {
        "b-modal": VBModal,
    },
};
</script>

<style scoped>
.modal-title {
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 20px !important;
    font-weight: bold;
}
</style>
